interface ProgressSpinnerProps {
  progress: number; // 0-100
  size?: number;
}

export function ProgressSpinner({ progress, size = 32 }: ProgressSpinnerProps) {
  const radius = (size - 4) / 2; // Account for stroke width
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="relative inline-flex items-center justify-center">
      <svg
        className="transform -rotate-90"
        height={size}
        width={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle */}
        <circle
          className="text-bg-quaternary"
          cx={size / 2}
          cy={size / 2}
          fill="transparent"
          r={radius}
          stroke="currentColor"
          strokeWidth="4"
        />
        {/* Progress circle */}
        <circle
          className="text-fg-brand-primary-alt transition-all duration-300 ease-out"
          cx={size / 2}
          cy={size / 2}
          fill="transparent"
          r={radius}
          stroke="currentColor"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          strokeWidth="4"
        />
      </svg>
    </div>
  );
}
